import {AnyAction} from "redux";
import {SET_OUTAGE_ID} from "../actions/action";
import * as _ from 'lodash';
import {getOutages, IOutage} from "../../data/data";
import {createSelector} from "reselect";


//  define selectors

export const getOutageID = state => state.outage;

/**
 * get the data object for a outage
 */
export const getOutageData = createSelector(

    [getOutageID],

    (outage_id: string) =>
    {
        const outages: IOutage[] = getOutages();

        return _.find(outages, ['id', outage_id]);
    }
);

/**
 * get the data object for a outage
 */
export const getOutageAffectedPowerSources = createSelector(

    [getOutageData],

    (outage: IOutage) : string[] =>
    {
        console.log('getOutageAffectedPowerSources: outage', outage);

        if (! outage) return null;

        return outage.affects;
    }
);

//  define the initial state

const initialState: string = null;


/**
 * reducer: set the current outage ID
 * @param {number} state
 * @param {AnyAction} action
 * @returns {number}
 */
export function outageID(state: string = initialState, action: AnyAction): string
{
    switch (action.type)
    {
        case SET_OUTAGE_ID:
        {
            const {payload} = action;
            const {outage_id} = payload;

            return outage_id;
        }

        default:

            return state;
    }
}



// WEBPACK FOOTER //
// ./src/ts/store/reducers/outage.ts